module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/7qbu579VG3rslW2zOEgYrA-142d6e8939cf8459353dfd97659e7591.jpg";